//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  head () {
    return {
      title: this.getTitle('Support'),
      meta: [
        ...this.getDescription('Questions? We\'re here to help!'),
        { hid: 'og:title', property: 'og:title', content: this.getTitle('Support') }
      ]
    }
  }
}
